import { css } from '@emotion/css';
import { showHideEffect } from 'constants/global.style';
import { colors } from 'constants/theme';

const headerMenuStyles = {
    wrap: css`
        position: relative;
        height: 58px;
        background: ${colors.darkSecondary};
        z-index: 3;
    `,
    menuList: css`
        list-style-type: none;
        display: flex;
        align-items: stretch;
        justify-content: flex-start;
        gap: 36px;
        height: 58px;
        @media (max-width: 1440px) {
            gap: 22px;
        }
    `,
    pointerGame: css`
        cursor: pointer;
    `,
    menuItem: css`
        display: flex;
        align-items: stretch;
        position: relative;
        &:first-child {
            p,
            a {
                padding-left: 0;
            }
        }
        &:hover > div h6,
        &.active > div h6 {
            color: ${colors.secondary};
        }

    `,
    itemGame: css`
        height: 58px;
        align-items: center;
        justify-content: center;
        display: flex;
        padding: 0;
        cursor: pointer;
        position: relative;
        transition: color 180ms ease, transform 180ms ease;
        &::after {
            content: '';
            position: absolute;
            left: 50%;
            bottom: 0;
            width: calc(100% + 16px);
            height: 3px;
            border-radius: 3px 3px 0 0;
            background: linear-gradient(90deg, transparent, ${colors.secondary}, transparent);
            transform: translateX(-50%) scaleX(0);
            transform-origin: center;
            transition: transform 220ms ease;
        }
        &:hover {
            transform: translateY(-2px);
            img:not(.new) {
                filter: brightness(0) saturate(100%) invert(82%) sepia(45%) saturate(603%) hue-rotate(342deg);
            }
            h6 {
                color: ${colors.secondary};
            }
            &::after { transform: translateX(-50%) scaleX(1); }
        }
        .new {
            position: absolute;
            width: 44px;
            height: 44px;
            z-index: 11;
            top: -30px;
            margin-left: 85px;
        }
    `,
    menuLink: css`
        font-family: var(--font-lato), sans-serif;
        font-weight: bold;
        color: ${colors.white};
        text-transform: uppercase;
        text-decoration: none;
        position: relative;
        z-index: 1;
        overflow: hidden;
        font-size: 16px;
        text-align: center;
        min-width: 0;
        text-transform: uppercase;
        text-align: center;
        .label-hot {
            position: absolute;
            top: 4px;
            right: 0;
            display: block;
            background: ${colors.darkRed};
            font-size: 10px;
            font-weight: 600;
            padding: 2px 4px;
            border-radius: 4px;
            animation: ${showHideEffect} 1s ease-in-out infinite;
        }
    `,
    baseGameHover: css`
        position: absolute;
        top: 100%;
        left: 0;
        z-index: 20;
        width: 100%;
        max-height: 0;
        overflow: hidden;
        visibility: hidden;
        opacity: 0;
        pointer-events: none;
        background: linear-gradient(180deg, rgba(8, 18, 38, .98), rgba(10, 24, 48, .98));
        border-top: 1px solid rgba(255, 217, 138, .28);
        box-shadow: 0 16px 26px rgba(0, 0, 0, .34);
        transition: max-height 260ms ease, opacity 180ms ease, visibility 0s linear 260ms;
    `,
    baseGameHoverOpen: css`
        max-height: 620px;
        visibility: visible;
        opacity: 1;
        pointer-events: auto;
        transition: max-height 320ms ease, opacity 180ms ease;
    `,
    gameList: css`
        min-height: 1px;
        animation: menuDrop 220ms ease both;

        @keyframes menuDrop {
            from { opacity: 0; transform: translateY(-8px); }
            to { opacity: 1; transform: translateY(0); }
        }
    `,
    showMenuGame: css`
        width: 100%;
        max-width: 1300px;
        margin: 0 auto;
    `,
    containerGameList: css`
        display: grid;
        grid-template-columns: repeat(5, minmax(0, 1fr));
        width: 100%;
        gap: 14px;
        padding: 20px 12px;
        @media (max-width: 1080px) { grid-template-columns: repeat(4, minmax(0, 1fr)); }
        @media (max-width: 780px) { grid-template-columns: repeat(3, minmax(0, 1fr)); }
    `,
    gameItem: css`
        position: relative;
        min-width: 0;
        text-align: center;
        display: flex;
        justify-content: center;
        transition: transform 180ms ease;
        &:hover {
            transform: translateY(-4px);
        }
        .gameArtwork {
            position: relative;
            display: flex;
            width: min(100%, 208px);
            height: 278px;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            border: 1px solid rgba(124, 148, 234, .52);
            border-radius: 9px;
            background: radial-gradient(circle at 78% 18%, rgba(255, 194, 72, .22), transparent 35%), linear-gradient(135deg, #213f70, #0d1d39);
            box-shadow: 0 8px 16px rgba(0, 0, 0, .22);
            transition: border-color 180ms ease, box-shadow 180ms ease;
            &::after {
                content: '';
                position: absolute;
                inset: 0;
                pointer-events: none;
                background: linear-gradient(135deg, rgba(21, 48, 91, .26), rgba(255, 173, 51, .08));
            }
        }
        .gameArtwork img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
            object-position: center;
            transition: transform 180ms ease, filter 180ms ease;
            filter: saturate(.84) hue-rotate(6deg) brightness(.96);
            &:hover {
                transform: scale(1.025);
                filter: saturate(1.06) hue-rotate(4deg) brightness(1.08);
            }
        }
        &:hover .gameArtwork {
            border-color: rgba(255, 217, 138, .9);
            box-shadow: 0 13px 22px rgba(0, 0, 0, .32), 0 0 14px rgba(255, 173, 51, .12);
        }
        .new {
            position: absolute;
            width: 44px;
            height: 44px;
            z-index: 1;
            top: -5px;
            right: -5px;
            border: 0;
            background: transparent;
            box-shadow: none;
        }

        .contentGame {
            display: flex;
            gap: 6px;
            justify-content: center;
            position: absolute;
            bottom: 7px;
            left: 50%;
            width: min(calc(100% - 14px), 194px);
            transform: translateX(-50%);
        }

        .buttonType {
            flex: 1;
            padding: 5px;
            background: rgba(255, 255, 255, .94);
            border-radius: 4px;
            transition: background 160ms ease, transform 160ms ease;
            &:hover { background: ${colors.secondary}; transform: translateY(-2px); }
            p {
                color: #282c35;
                cursor: pointer;
                text-transform: uppercase;
            }
        }
    `,
    gameName: css`
        text-align: center;
        color: ${colors.white};
        font-size: 12px;
        font-family: 'UTM Avo', sans-serif;
    `,
    marquee: css`
        background: ${colors.primary};
    `,
    megaphone: css`
        width: 20px;
        margin-left: 12px;
    `,
    titleNoti: css`
        background: -webkit-linear-gradient(28deg, #ddca8c, #fcf3d4, #ddca8c, #fcf3d4, #ddca8c);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin-left: 5px;
        text-transform: uppercase;
        font-size: 14px;
        width: 100px;
        z-index: 2;
    `,
    timeNow: css`
        display: flex;
        align-items: center;
        flex: 0 0 156px;
    `,
    slideTimer: css`
        display: flex;
        background-color: ${colors.primary};
        width: 100%;
    `,
    slideText: css`
        /* flex: 1; */
        /* max-width: calc(100% - 156px); */
        width: 100%;
        position: relative;
        /* height: 40px; */
        &::before,
        &::after {
            content: '';
            position: absolute;
            top: 0;
            width: 120px;
            height: 100%;
            z-index: 2;
            pointer-events: none;
        }
    `,

    itemGamePromotion: css`
        height: 58px;
        align-items: center;
        justify-content: center;
        display: flex;
        cursor: pointer;
        position: relative;
        transition: transform 180ms ease;
        &::after {
            content: '';
            position: absolute;
            left: 50%;
            bottom: 0;
            width: calc(100% + 16px);
            height: 3px;
            border-radius: 3px 3px 0 0;
            background: linear-gradient(90deg, transparent, ${colors.secondary}, transparent);
            transform: translateX(-50%) scaleX(0);
            transition: transform 220ms ease;
        }
        &:hover {
            transform: translateY(-2px);
            h6 { color: ${colors.secondary}; }
            &::after { transform: translateX(-50%) scaleX(1); }
        }
    `,

    menuLinkPromotion: css`
        font-family: var(--font-lato), sans-serif;
        font-weight: bold;
        color: ${colors.white};
        text-transform: uppercase;
        text-decoration: none;
        position: relative;
        z-index: 1;
        font-size: 16px;
        text-align: center;
        min-width: 0;
    `,
};

export default headerMenuStyles;
